// tslint:disable
/**
 * JLIVE ADMIN API
 * JLIVE ADMIN API
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ImageDisplay } from '.';

/**
 * @export
 * @interface EventImageTranslationDisplay
 */
export interface EventImageTranslationDisplay {
  /**
   * @type {number}
   * @memberof EventImageTranslationDisplay
   */
  readonly id?: number;
  /**
   * @type {boolean}
   * @memberof EventImageTranslationDisplay
   */
  readonly main?: boolean;
  /**
   * @type {number}
   * @memberof EventImageTranslationDisplay
   */
  readonly order?: number;
  /**
   * @type {string}
   * @memberof EventImageTranslationDisplay
   */
  image_type: EventImageTranslationDisplayImageTypeEnum;
  /**
   * @type {ImageDisplay}
   * @memberof EventImageTranslationDisplay
   */
  image_en?: ImageDisplay;
  /**
   * @type {ImageDisplay}
   * @memberof EventImageTranslationDisplay
   */
  image_he?: ImageDisplay;
  /**
   * @type {ImageDisplay}
   * @memberof EventImageTranslationDisplay
   */
  image_fr?: ImageDisplay;
}

/**
 * @export
 * @enum {string}
 */
export enum EventImageTranslationDisplayImageTypeEnum {
  Empty = '',
  Logo = 'logo',
  Avatar = 'avatar',
  Market = 'market',
  Organization = 'organization',
  Event = 'event',
  EventArchive = 'event_archive',
  HeroImage = 'hero_image',
  EventSponsors = 'event_sponsors',
  OrganizationHeroImage = 'organization_hero_image',
}
